(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const initialReducedMotion = reduced.matches;
  const safari=navigator.vendor === 'Apple Computer, Inc.' && /Safari\//.test(navigator.userAgent) && !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR\/|OPiOS|Android/.test(navigator.userAgent);
  const webpLoads=new Map();
  const webpDecodes=new Map();
  function preservedWebP(url) {
    if(webpLoads.has(url)) return webpLoads.get(url);
    const pending=Promise.resolve().then(()=>fetch(url,{credentials:'omit'})).then(response=>{
      if(!response.ok) throw new Error('Image data unavailable');
      return response.json();
    }).then(result=>{
      if(typeof result?.src !== 'string' || !/^data:image\/webp;base64,[A-Za-z0-9+/]+={0,2}$/.test(result.src)) throw new Error('Invalid image data');
      return result.src;
    }).catch(error=>{
      if(webpLoads.get(url) === pending) webpLoads.delete(url);
      throw error;
    });
    webpLoads.set(url,pending);
    return pending;
  }
  function verifyWebP(url,uri) {
    if(webpDecodes.has(url)) return webpDecodes.get(url);
    const pending=new Promise((resolve,reject)=>{
      const probe=new Image();
      const canDecode=typeof probe.decode === 'function';
      probe.onerror=()=>reject(new Error('Image data could not load'));
      if(!canDecode) probe.onload=resolve;
      probe.src=uri;
      if(canDecode) probe.decode().then(resolve,reject);
    }).catch(error=>{
      if(webpDecodes.get(url) === pending) webpDecodes.delete(url);
      throw error;
    });
    webpDecodes.set(url,pending);
    return pending;
  }
  document.querySelectorAll('img[data-nimg]').forEach(image => {
    function decodeLoadedImage() {
      const source=image.src;
      if(image['data-loaded-src'] === source) return;
      image['data-loaded-src']=source;
      if(typeof image.decode === 'function') image.decode().catch(()=>{});
    }
    let preservation;
    if(safari && image.hasAttribute('data-lv-webp-srcset')) {
      try {
        const original=image.getAttribute('srcset');
        const candidates=original.split(',').map(value=>{
          const match=value.trim().match(/^(\S+)\s+([1-9]\d*w)$/);
          if(!match) throw new Error('Invalid image candidates');
          return {value:value.trim(),source:new URL(match[1],document.baseURI).href,descriptor:match[2]};
        });
        const entries=JSON.parse(image.getAttribute('data-lv-webp-srcset'));
        if(!Array.isArray(entries)) throw new Error('Invalid image mapping');
        const mapping=new Map(entries.map(entry=>{
          if(typeof entry?.source !== 'string' || typeof entry?.data !== 'string') throw new Error('Invalid image mapping');
          return [new URL(entry.source,document.baseURI).href,new URL(entry.data,document.baseURI).href];
        }));
        let pending=null,replacement=null,lastSource=null,failedSource=null,revision=0,frame;
        function selectedSource() {
          const selected=image.currentSrc;
          if(replacement && selected === replacement.uri) return replacement.source;
          return selected ? new URL(selected,document.baseURI).href : '';
        }
        function restore(source) {
          revision++;pending=null;failedSource=source;
          if(replacement?.applied) {replacement.applied=false;image.setAttribute('srcset',original);}
          if(image.complete) decodeLoadedImage();
        }
        function update() {
          if(!image.isConnected) return;
          const source=selectedSource();
          if(!source) return;
          if(source !== lastSource) {lastSource=source;failedSource=null;revision++;pending=null;}
          if(replacement?.applied && image.currentSrc === replacement.uri) {
            if(image.complete && image.naturalWidth) decodeLoadedImage();
            return;
          }
          if(!image.complete) return;
          const resource=mapping.get(source);
          if(!resource || failedSource === source || !candidates.some(candidate=>candidate.source === source)) {decodeLoadedImage();return;}
          if(pending?.source === source) return;
          const request={source,revision:++revision};
          pending=request;
          preservedWebP(resource).then(uri=>{
            if(pending !== request || request.revision !== revision || !image.isConnected || selectedSource() !== source) return;
            return verifyWebP(resource,uri).then(()=>{
              if(pending !== request || request.revision !== revision || !image.isConnected || selectedSource() !== source) return;
              pending=null;replacement={source,uri,applied:true};
              image.setAttribute('srcset',candidates.map(candidate=>candidate.source === source ? `${uri} ${candidate.descriptor}` : candidate.value).join(', '));
              if(image.complete && image.currentSrc === uri && image.naturalWidth) decodeLoadedImage();
            });
          }).catch(()=>{
            if(pending === request && request.revision === revision && image.isConnected && selectedSource() === source) restore(source);
          });
        }
        function viewportChanged() {
          revision++;pending=null;
          if(!frame) frame=requestAnimationFrame(()=>{frame=undefined;update();});
        }
        image.addEventListener('error',()=>{
          if(replacement?.applied && image.currentSrc === replacement.uri) restore(replacement.source);
          else update();
        });
        window.addEventListener('resize',viewportChanged);
        window.addEventListener('orientationchange',viewportChanged);
        window.addEventListener('online',()=>{failedSource=null;update();});
        preservation=update;
      } catch {}
    }
    const loaded=preservation || decodeLoadedImage;
    image.addEventListener('load',loaded);
    if(image.complete) loaded();
  });
  document.querySelector('.skip-link')?.addEventListener('click', event => {
    const content=document.getElementById('main-content');
    if(!content) return;
    event.preventDefault();
    if(!content.hasAttribute('tabindex')) content.setAttribute('tabindex','-1');
    content.focus({preventScroll:true});
    content.scrollIntoView();
  });
  const header = document.querySelector('.site-header');
  const toggle = header?.querySelector('.menu-toggle');
  const menu = document.getElementById('mobile-menu');
  let menuOpen = false;
  let menuRevision = 0;
  const menuIcon = '<path d="M4 5h16"></path><path d="M4 12h16"></path><path d="M4 19h16"></path>';
  const closeIcon = '<path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>';
  const menuLinkAnimations = new WeakMap();
  function animateMenuLink(link,index) {
    const previous=menuLinkAnimations.get(link);
    if(previous) {previous.cancelled=true;previous.opacity.cancel();}
    const motion={cancelled:false,opacity:link.animate([{opacity:0},{opacity:1}],{duration:300,delay:index*40,fill:'backwards',easing:'cubic-bezier(0.25,0.1,0.35,1)'})};
    menuLinkAnimations.set(link,motion);
    const start=performance.now()+index*40;
    const alpha=25/2/1000;
    const frequency=Math.sqrt(500-Math.pow(25/2,2))/1000;
    const coefficient=alpha*12/frequency;
    link.style.transform='translateX(-12px)';
    function update(now) {
      if(motion.cancelled) return;
      if(initialReducedMotion) {motion.opacity.cancel();link.style.transform='none';return;}
      const elapsed=Math.max(0,now-start);
      const decay=Math.exp(-alpha*elapsed);
      const sine=Math.sin(frequency*elapsed),cosine=Math.cos(frequency*elapsed);
      const position=-decay*(coefficient*sine+12*cosine);
      const velocity=1000*decay*((alpha*coefficient+12*frequency)*sine+(alpha*12-coefficient*frequency)*cosine);
      const finished=now>=start&&Math.abs(velocity)<=10&&Math.abs(position)<=0.5;
      link.style.transform=finished?'none':`translateX(${position}px)`;
      if(!finished) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }
  function setMenu(open, restoreFocus = false) {
    menuOpen = open;
    const revision = ++menuRevision;
    document.body.classList.toggle('menu-open', open);
    document.querySelectorAll('main, footer').forEach(region => region.inert = open);
    toggle?.setAttribute('aria-expanded', String(open));
    toggle?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    if (toggle?.querySelector('svg')) toggle.querySelector('svg').innerHTML = open ? closeIcon : menuIcon;
    if (menu) {
      if(open) {
        const wasHidden=menu.hidden;
        menu.hidden=false;
        menu.style.opacity='1';menu.style.transform='none';
        if(wasHidden) menu.scrollTop=0;
      } else if(!initialReducedMotion && !menu.hidden) {
        const style=getComputedStyle(menu);
        menu.animate([{opacity:style.opacity,transform:style.transform},{opacity:0,transform:'translateY(-12px)'}],{duration:250,easing:'ease-out'}).finished.then(()=>{if(revision===menuRevision)menu.hidden=true;});
      } else menu.hidden=true;
      if (open && !initialReducedMotion) {
        const opening=menu.animate([{opacity:0,transform:'translateY(-12px)'},{opacity:1,transform:'translateY(0)'}],{duration:250,easing:'ease-out'});
        opening.finished.then(()=>{
          if(revision === menuRevision && menuOpen) {menu.style.opacity='1';menu.style.transform='none';}
          opening.cancel();
        }).catch(()=>{});
        menu.querySelectorAll('a:not(.mobile-nav__cta)').forEach(animateMenuLink);
      }
    }
    if (restoreFocus) requestAnimationFrame(() => toggle?.focus());
  }
  toggle?.addEventListener('click', () => setMenu(!menuOpen));
  if(toggle) toggle.hidden=false;
  header?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', event => {
    if (!menuOpen) return;
    if (event.key === 'Escape') { setMenu(false,true); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...header.querySelectorAll('a[href],button:not([disabled])')].filter(el => el.getClientRects().length);
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  matchMedia('(min-width: 901px)').addEventListener('change', e => { if(e.matches) setMenu(false); });
  header?.querySelectorAll('nav a').forEach(link => {
    if (link.pathname === location.pathname && !link.hash) link.setAttribute('aria-current','page');
  });
  function openFaq(hash, scroll = true) {
    let entry;
    try { entry = document.getElementById(decodeURIComponent(hash.slice(1))); } catch { return; }
    if (entry?.tagName !== 'DETAILS') return;
    entry.open = true;
    entry.querySelector('summary')?.focus({preventScroll:true});
    if(scroll) entry.scrollIntoView({block:'start'});
  }
  window.addEventListener('hashchange', () => openFaq(location.hash));
  document.querySelectorAll('a[href]').forEach(link => link.addEventListener('click', event => {
    if(event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if(link.origin !== location.origin || link.pathname !== location.pathname || link.search !== location.search || !link.hash) return;
    const same = link.hash === location.hash;
    let entry; try {entry=document.getElementById(decodeURIComponent(link.hash.slice(1)));}catch{return;}
    if(entry?.tagName !== 'DETAILS') return;
    if(same) event.preventDefault();
    openFaq(link.hash,same);
  }));
  openFaq(location.hash);
  window.addEventListener('pageshow', event => {
    if(!event.persisted) requestAnimationFrame(() => openFaq(location.hash,false));
  });
  const illustration = document.getElementById('hardware-illustration');
  const features = ['connection','microphone','speaker'];
  function highlight(id) {
    illustration?.querySelectorAll('svg g').forEach((g,index) => g.dataset.active = String(features[index] === id));
    illustration?.querySelectorAll('[data-side]').forEach((marker,index) => {
      marker.dataset.active = String(features[index] === id);
      marker.querySelector('button')?.setAttribute('aria-pressed', String(features[index] === id));
    });
    features.forEach(feature => {
      const article = document.getElementById('hardware-'+feature);
      if(article) {
        article.dataset.active = String(feature === id);
        article.querySelector('button')?.setAttribute('aria-pressed',String(feature === id));
      }
    });
  }
  illustration?.querySelectorAll('button').forEach((button,index) => ['click','mouseenter','focus'].forEach(event => button.addEventListener(event,() => highlight(features[index]))));
  document.querySelectorAll('[data-feature]').forEach(button => ['click','mouseenter','focus'].forEach(event => button.addEventListener(event,() => highlight(button.dataset.feature))));
  const journey = document.getElementById('how-it-works');
  let frame;
  function updateRoute() {
    frame = undefined;
    if(!journey) return;
    let top=0;
    for(let element=journey;element && element !== document.documentElement;element=element.offsetParent) top+=element.offsetTop;
    const height=document.documentElement.clientHeight;
    const progress = Math.max(0,Math.min(1,(scrollY-top+height*.7)/(journey.offsetHeight+height*.1)));
    const track = journey.querySelector('.voice-route__progress');
    const pulse = journey.querySelector('.voice-route__pulse');
    if(track) track.style.transform = initialReducedMotion || progress === 1 ? 'none' : `scaleX(${.03+.97*progress})`;
    if(pulse) pulse.style.left = initialReducedMotion ? '50%' : `${progress*100}%`;
  }
  window.addEventListener('scroll',() => {if(!frame) frame=requestAnimationFrame(updateRoute);},{passive:true});
  window.addEventListener('resize',updateRoute);
  updateRoute();
  if(!reduced.matches && 'IntersectionObserver' in window) {
    document.querySelectorAll('[data-reveal]').forEach(el => {
      if(el.getBoundingClientRect().top <= innerHeight) return;
      const distance=Number(el.dataset.reveal || 24);
      const animation=el.animate([{transform:`translateY(${distance}px)`},{transform:'translateY(0)'}],{duration:700,easing:'cubic-bezier(0.22,1,0.36,1)',fill:'backwards'});
      animation.pause(); animation.currentTime=0;
      const observer=new IntersectionObserver(([entry])=>{if(entry.isIntersecting){animation.play();observer.disconnect();}},{rootMargin:'0px 0px 64px 0px'});
      observer.observe(el);
      reduced.addEventListener('change',()=>{if(reduced.matches){animation.cancel();observer.disconnect();}});
    });
  }
  const host=document.querySelector('.shopify-host');
  const embed=document.querySelector('.shopify-embed');
  if(host && embed) {
    host.classList.remove('shopify-host--pending');
    let fallback;
    function failed() {
      if(fallback) return;
      embed.classList.add('shopify-embed--failed');
      fallback=document.createElement('div');
      fallback.className='commerce-fallback';fallback.setAttribute('role','status');
      const paragraph=document.createElement('p');paragraph.textContent='Live price and availability could not load here.';fallback.append(paragraph);
      host.after(fallback);
    }
    const timer=setTimeout(failed,12000);
    document.querySelector('script[src="https://cdn.shopify.com/storefront/web-components.js"]')?.addEventListener('error',failed);
    new MutationObserver(()=>{
      if(host.querySelector('.shopify-error')) {clearTimeout(timer);failed();}
      else if(host.querySelector('.live-product')) {clearTimeout(timer);embed.classList.remove('shopify-embed--failed');fallback?.remove();fallback=undefined;}
    }).observe(host,{attributes:true,childList:true,subtree:true});
  }
  const form=document.querySelector('[data-lv-contact]');
  if(form) {
    function alternateContact() {
      if(form.querySelector('[data-contact-alternate]')) return;
      const template=document.getElementById('lv-contact-alternate');
      if(template) form.querySelector('fieldset [class*=__submit]').before(template.content.cloneNode(true));
    }
    const topics=new URLSearchParams(location.search).getAll('topic');
    const topic=topics.length === 1 ? topics[0] : null;
    const select=form.querySelector('select');
    if([...select.options].some(option => option.value === topic)) select.value=topic;
    if(topic === 'privacy') {
      const intro=document.querySelector('[class*=contact-module][class*=__intro]');
      intro.querySelector('h1 + p').textContent='Ask a privacy question or request access to, correction or deletion of personal information. You do not need an account or order number. Please avoid including identity documents or private recordings.';
    }
    let sending=false;
    let serviceErrors=false;
    function clearContactErrors() {
      serviceErrors=false;
      form.querySelectorAll('[data-form-error]').forEach(el=>el.remove());
      form.querySelectorAll('[data-contact-alternate]').forEach(el=>el.remove());
      form.querySelectorAll('[aria-invalid]').forEach(el=>{el.setAttribute('aria-invalid','false');el.removeAttribute('aria-describedby');});
    }
    async function submitContact(data) {
      try {
        const response=await fetch(form.action,{method:'POST',body:data,headers:{Accept:'application/json'}});
        const result=await response.json();
        if(result !== null && typeof result === 'object') {
          const errors=Array.isArray(result.errors) && result.errors.every(error => typeof error.message === 'string');
          if(errors || typeof result.error === 'string') return {errors:Array.isArray(result.errors) ? result.errors : [{message:result.error}]};
          if(typeof result.next === 'string') return {success:true};
        }
        return {errors:[{message:'Unexpected response format'}]};
      } catch(error) {
        return {errors:[{message:error instanceof Error ? error.message : `Unknown error while posting to Formspree: ${JSON.stringify(error)}`}]};
      }
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(sending) return;sending=true;
      const data=new FormData(form);
      const fieldset=form.querySelector('fieldset');
      const button=form.querySelector('[type=submit]');
      const original=button.innerHTML;
      form.querySelectorAll('[data-form-error="unexpected"]').forEach(el=>el.remove());
      if(!serviceErrors) form.querySelectorAll('[data-contact-alternate]').forEach(el=>el.remove());
      fieldset.disabled=true;form.setAttribute('aria-busy','true');button.firstChild.textContent='Sending…';
      try {
        const result=await submitContact(data);
        clearContactErrors();
        if(result.errors) {
          serviceErrors=true;
          const groups=new Map();
          result.errors.forEach(error=>{
            const key=error.field || '';
            if(!groups.has(key)) groups.set(key,[]);
            groups.get(key).push(error.message);
          });
          groups.forEach((messages,field)=>{
            const fields=['name','email','topic','orderNumber','message'];
            if(field && !fields.includes(field)) return;
            const error=document.createElement('div');error.dataset.formError='';error.setAttribute('role','alert');
            const input=field ? [...form.elements].find(el=>el.name === field) : null;
            const prefix={name:'Name',email:'Email',orderNumber:'Order number',message:'Message'}[field];
            error.textContent=(prefix ? prefix+' ' : '')+messages.join(', ');
            error.className='contact-module__GWfRQa__'+(input ? 'fieldError' : 'error');
            if(input){
              error.id=input.id+'-error';input.setAttribute('aria-invalid','true');input.setAttribute('aria-describedby',error.id);input.closest('label').after(error);
            }else fieldset.querySelector('[class*=__submit]').before(error);
          });
          alternateContact();
          return;
        }
        const success=document.getElementById('lv-contact-success').content.cloneNode(true);
        success.querySelector('[data-reply-email]').textContent=String(data.get('email') || '').trim();
        form.replaceWith(success);document.querySelector('[data-contact-result]').focus();
      } catch {
        clearContactErrors();
        const p=document.createElement('p');p.className='contact-module__GWfRQa__error';p.dataset.formError='unexpected';p.setAttribute('role','alert');
        p.textContent='We couldn’t confirm your message was sent. Your details are still here; please try again shortly.';
        fieldset.querySelector('[class*=__submit]').before(p);
        alternateContact();
      } finally {sending=false;fieldset.disabled=false;form.setAttribute('aria-busy','false');button.innerHTML=original;}
    });
  }
  const privacy=document.getElementById('lv-privacy');
  if(privacy) {
    const notice=privacy.querySelector('section');
    const preferences=privacy.querySelector('.store-analytics-module__MSOaLW__preferences');
    let choice=null;try{choice=localStorage.getItem('littlevoice-theme-analytics');}catch{}
    const hasChoice=choice === 'yes' || choice === 'no';
    notice.hidden=hasChoice;
    preferences.hidden=!hasChoice;
    let consentRevision=0;
    function applyTrackingConsent(analytics) {
      const revision=++consentRevision;
      const save=()=>{
        if(revision === consentRevision) window.Shopify?.customerPrivacy?.setTrackingConsent({analytics,marketing:false,preferences:true,sale_of_data:false},()=>{});
      };
      if(window.Shopify?.customerPrivacy) save();
      else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)save();});
    }
    applyTrackingConsent(choice === 'yes');
    preferences.addEventListener('click',()=>{notice.hidden=false;preferences.hidden=true;applyTrackingConsent(false);});
    privacy.querySelectorAll('[data-consent]').forEach(button=>button.addEventListener('click',()=>{
      const analytics=button.dataset.consent === 'yes';
      applyTrackingConsent(analytics);
      try{localStorage.setItem('littlevoice-theme-analytics',analytics ? 'yes' : 'no');}catch{}
      notice.hidden=true;
      preferences.hidden=false;
    }));
  }
})();
